"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductBuilderHeader = void 0;
const React = require("react");
const Modal_1 = require("../../../../../../components/base/structure/Modal");
const ProductBuilderCategoryTabPanel_1 = require("../ProductBuilderCategoryTabPanel");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(styles, "ProductBuilderHeader");
const ProductBuilderHeader = ({ salesOrderItemBuilt, scrollToCategory }) => {
    const { title, fullDescription, productBlueprint: { imageUrl } } = salesOrderItemBuilt;
    return (React.createElement(Modal_1.ModalHeader, { className: css("") },
        React.createElement("div", { className: css("image"), style: {
                backgroundImage: `url("${imageUrl}")`
            } }),
        React.createElement("div", { className: css("details") },
            React.createElement("div", { className: css("details_title") }, title),
            React.createElement("div", { className: css("details_build") }, fullDescription)),
        React.createElement(ProductBuilderCategoryTabPanel_1.ProductBuilderCategoryTabPanel, { salesOrderItemBuilt: salesOrderItemBuilt, scrollToCategory: scrollToCategory })));
};
exports.ProductBuilderHeader = ProductBuilderHeader;
//# sourceMappingURL=index.js.map